var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { DefiScoreTokenList, } from "../models/defiScore";
import { AssetsList } from "../store/types";
import { useFetchAssetsPrice } from "./useAssetPrice";
import { useFetchAssetsYield } from "./useAssetsYield";
import { useFetchYearnAPIData } from "./useYearnAPIData";
import { useTickerData } from "./useTickerData";
export var defaultAssetsPriceData = Object.fromEntries(AssetsList.map(function (asset) { return [asset, { latestPrice: 0, history: {} }]; }));
export var defaultAssetTickerData = Object.fromEntries(AssetsList.map(function (asset) { return [
    asset,
    {
        asset: asset,
        price: 0,
        dailyChange: 0,
    },
]; }));
export var defaultAssetsYieldData = Object.fromEntries(DefiScoreTokenList.map(function (token) { return [token, new Array(0)]; }));
export var defaultExternalAPIData = {
    assetsPrice: { data: defaultAssetsPriceData, loading: true },
    assetsYield: { data: defaultAssetsYieldData, loading: true },
    yearnAPIData: { data: [], loading: true },
    tickerData: { data: defaultAssetTickerData, loading: true },
};
export var ExternalAPIDataContext = React.createContext(defaultExternalAPIData);
export var ExternalAPIDataContextProvider = function (_a) {
    var children = _a.children;
    var assetsPrice = useFetchAssetsPrice();
    var assetsYield = useFetchAssetsYield();
    var yearnAPIData = useFetchYearnAPIData();
    var tickerData = useTickerData();
    // console.group("fetch api");
    // console.log(assetsPrice);
    // // console.log(assetsYield);
    // // console.log(yearnAPIData);
    // // console.log(tickerData);
    // console.groupEnd();
    return (_jsx(ExternalAPIDataContext.Provider, __assign({ value: {
            assetsPrice: assetsPrice,
            assetsYield: assetsYield,
            yearnAPIData: yearnAPIData,
            tickerData: tickerData,
        } }, { children: children }), void 0));
};
//# sourceMappingURL=externalAPIDataContext.js.map